import { TOAST_DURATION } from '@/constants'
import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { roundTo } from '@/utilities/crop-calculations.js'

export default {
  name: 'CropEditForm',
  components: {
    LayoutBasic
  },
  props: ['cropId'],
  data () {
    return {
      activeTab: 0,
      showIncomeItems: true,
      showExpenseItems: true,
      cropEditItem: '',
      cropCommodityEditItem: '',
      cropOtherIncomeEditItem: '',
      cropOtherExpenseEditItem: '',
      cropChemicalEditItem: '',
      cropFertilizerEditItem: '',
      cropSeedEditItem: '',
      cropIrrigationEditItem: '',
      productionEdit: false,
      formProduction: 0,
      formQuantity: 0,
      formCommodityProduction: 0,
      formOtherIncomeQuantity: 0,
      formOtherExpenseQuantity: 0,
      formChemicalApplicationRate: 0,
      formFertilizerApplicationRate: 0,
      formSeedSeedingRate: 0,
      formIrrigationQuantity: 0,
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 25
    }
  },
  computed: {
    seedItems () {
      return this.$store.getters.seedItemsList
    },
    customRateItems () {
      return this.$store.getters.customRateItemsList
    },
    otherExpenseItems () {
      return this.$store.getters.otherExpenseItemsList
    },
    chemicalItems () {
      return this.$store.getters.chemicalItemsList
    },
    fertilizerItems () {
      return this.$store.getters.fertilizerItemsList
    },
    irrigationItems () {
      return this.$store.getters.irrigationItemsList
    },
    commodityItems () {
      return this.$store.getters.commodityItemsList
    },
    otherIncomeItems () {
      return this.$store.getters.otherIncomeItemsList
    },
    customRateItemsForCrop () {
      return this.$store.getters.getCropExpenseCustomRateItemsByCropId(this.cropId)
    },
    otherExpenseItemsForCrop () {
      return this.$store.getters.getCropExpenseOtherExpenseItemsByCropId(this.cropId)
    },
    currentCrop () {
      return this.$store.getters.getCropById(this.cropId)
    },
    totalProfit () {
      return this.$store.getters.getCropProfitTotalByCropId(this.cropId)
    },
    formattedTotalProfit () {
      return roundTo(this.totalProfit)
    },
    totalExpense () {
      return this.$store.getters.getCropExpensesTotalByCropId(this.cropId)
    },
    formattedTotalExpense () {
      return roundTo(this.totalExpense)
    },
    totalIncome () {
      return this.$store.getters.getCropIncomeTotalByCropId(this.cropId)
    },
    formattedTotalIncome () {
      return roundTo(this.totalIncome)
    },
    currentCommodity () {
      return this.$store.getters.getCommodityItemById(this.currentCrop.commodityId)
    },
    commodityItemsForCrop () {
      return this.$store.getters.getCropIncomeCommodityItemsByCropId(this.cropId)
    },
    otherIncomeItemsForCrop () {
      return this.$store.getters.getCropIncomeOtherIncomeItemsByCropId(this.cropId)
    },
    chemicalItemsForCrop () {
      return this.$store.getters.getCropExpenseChemicalItemsByCropId(this.cropId)
    },
    fertilizerItemsForCrop () {
      return this.$store.getters.getCropExpenseFertilizerItemsByCropId(this.cropId)
    },
    seedItemsForCrop () {
      return this.$store.getters.getCropExpenseSeedItemsByCropId(this.cropId)
    },
    irrigationItemsForCrop () {
      return this.$store.getters.getCropExpenseIrrigationItemsByCropId(this.cropId)
    },
    otherExpenseTotalForCrop () {
      return roundTo(this.$store.getters.getCropExpenseOtherExpenseTotalByCropId(this.cropId))
    },
    irrigationTotalForCrop () {
      return roundTo(this.$store.getters.getCropExpenseIrrigationTotalByCropId(this.cropId))
    },
    fertilizerTotalForCrop () {
      return roundTo(this.$store.getters.getCropExpenseFertilizerTotalByCropId(this.cropId))
    },
    chemicalTotalForCrop () {
      return roundTo(this.$store.getters.getCropExpenseChemicalTotalByCropId(this.cropId))
    },
    customRateTotalForCrop () {
      return roundTo(this.$store.getters.getCropExpenseCustomRateTotalByCropId(this.cropId))
    },
    seedTotalForCrop () {
      return roundTo(this.$store.getters.getCropExpenseSeedTotalByCropId(this.cropId))
    },
    otherIncomeTotalForCrop () {
      return roundTo(this.$store.getters.getCropIncomeOtherIncomeTotalByCropId(this.cropId))
    },
    commodityTotalForCrop () {
      return roundTo(this.$store.getters.getCropIncomeCommodityTotalByCropId(this.cropId))
    }
  },
  methods: {
    addCommodityItemToCrop (commodityItem, cropId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: commodityItem.id,
        production: commodityItem.defaultProduction,
        cropId: cropId
      }

      this.$store.dispatch('addCommodityItemToCrop', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    addOtherIncomeItemToCrop (otherIncomeItem, cropId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: otherIncomeItem.id,
        quantity: otherIncomeItem.defaultQuantity,
        cropId: cropId
      }

      this.$store.dispatch('addOtherIncomeItemToCrop', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    addIrrigationItemToCrop (irrigationItem, cropId) {
      const jsConn = new JSConn()
      jsConn.formParams = {
        itemId: irrigationItem.id,
        cropId: cropId,
        quantity: irrigationItem.defaultQuantity
      }

      this.$store.dispatch('addIrrigationItemToCrop', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },

    addSeedItemToCrop (seedItem, cropId) {
      const jsConn = new JSConn()
      jsConn.formParams = {
        itemId: seedItem.id,
        seedingRate: seedItem.defaultSeedingRate,
        cropId: cropId
      }

      this.$store.dispatch('addSeedItemToCrop', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    addCustomRateItemToCrop (item, cropId) {
      const jsConn = new JSConn()
      jsConn.formParams = {
        itemId: item.id,
        quantity: item.defaultQuantity,
        cropId: cropId
      }

      this.$store.dispatch('addCustomRateItemToCrop', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    addOtherExpenseItemToCrop (item, cropId) {
      const jsConn = new JSConn()
      jsConn.formParams = {
        itemId: item.id,
        quantity: item.defaultQuantity,
        cropId: cropId
      }

      this.$store.dispatch('addOtherExpenseItemToCrop', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    addChemicalItemToCrop (chemicalItem, cropId) {
      const jsConn = new JSConn()
      jsConn.formParams = {
        applicationRate: chemicalItem.defaultApplicationRate,
        itemId: chemicalItem.id,
        cropId: cropId
      }
      this.$store.dispatch('addChemicalItemToCrop', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    addFertilizerItemToCrop (fertilizerItem, cropId) {
      const jsConn = new JSConn()
      jsConn.formParams = {
        applicationRate: fertilizerItem.defaultApplicationRate,
        itemId: fertilizerItem.id,
        cropId: cropId
      }
      this.$store.dispatch('addFertilizerItemToCrop', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    deleteCropExpenseCustomRateItem (itemId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: itemId,
        cropId: this.cropId
      }

      this.$store.dispatch('deleteCropExpenseCustomRateItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    deleteCropExpenseOtherExpenseItem (itemId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: itemId,
        cropId: this.cropId
      }

      this.$store.dispatch('deleteCropExpenseOtherExpenseItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    editCropCommodityItem (itemId, production) {
      if (itemId === this.cropCommodityEditItem) {
        this.cropCommodityEditItem = ''
      } else {
        this.cropCommodityEditItem = itemId
        this.formCommodityProduction = production
      }
    },
    editCropOtherIncomeItem (itemId, quantity) {
      if (itemId === this.cropOtherIncomeEditItem) {
        this.cropOtherIncomeEditItem = ''
      } else {
        this.cropOtherIncomeEditItem = itemId
        this.formOtherIncomeQuantity = quantity
      }
    },
    editCropCustomRateItem (itemId, quantity) {
      if (itemId === this.cropEditItem) {
        this.cropEditItem = ''
      } else {
        this.cropEditItem = itemId
        this.formQuantity = quantity
      }
    },
    editCropOtherExpenseItem (itemId, quantity) {
      if (itemId === this.cropEditItem) {
        this.cropOtherExpenseEditItem = ''
      } else {
        this.cropOtherExpenseEditItem = itemId
        this.formQuantity = quantity
      }
    },
    editCropChemicalItem (itemId, applicationRate) {
      if (itemId === this.cropChemicalEditItem) {
        this.cropChemicalEditItem = ''
      } else {
        this.cropChemicalEditItem = itemId
        this.formChemicalApplicationRate = applicationRate
      }
    },
    editCropFertilizerItem (itemId, applicationRate) {
      if (itemId === this.cropFertilizerEditItem) {
        this.cropFertilizerEditItem = ''
      } else {
        this.cropFertilizerEditItem = itemId
        this.formFertilizerApplicationRate = applicationRate
      }
    },
    editCropSeedItem (itemId, seedingRate) {
      if (itemId === this.cropSeedEditItem) {
        this.cropSeedEditItem = ''
      } else {
        this.cropSeedEditItem = itemId
        this.formSeedSeedingRate = seedingRate
      }
    },
    editCropIrrigationItem (itemId, quantity) {
      if (itemId === this.cropIrrigationEditItem) {
        this.cropIrrigationEditItem = ''
      } else {
        this.cropIrrigationEditItem = itemId
        this.formIrrigationQuantity = quantity
      }
    },
    submitCustomRateQuantityEdit (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: this.cropEditItem,
        quantity: this.formQuantity
      }
      this.$store.dispatch('updateCropCustomRateDetailQuantity', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })

      // reset the values
      this.cropEditItem = ''
      this.formQuantity = 0
    },
    submitOtherExpenseQuantityEdit (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: this.cropOtherExpenseEditItem,
        quantity: this.formQuantity
      }
      this.$store.dispatch('updateCropOtherExpenseDetailQuantity', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })

      // reset the values
      this.cropOtherExpenseEditItem = ''
      this.formQuantity = 0
    },
    submitChemicalApplicationRateEdit (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: this.cropChemicalEditItem,
        applicationRate: this.formChemicalApplicationRate
      }
      this.$store.dispatch('updateCropChemicalDetailApplicationRate', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })

      // reset the values
      this.cropChemicalEditItem = ''
      this.formChemicalApplicationRate = 0
    },
    submitFertilizerApplicationRateEdit (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: this.cropFertilizerEditItem,
        applicationRate: this.formFertilizerApplicationRate
      }
      this.$store.dispatch('updateCropFertilizerDetailApplicationRate', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })

      // reset the values
      this.cropFertilizerEditItem = ''
      this.formFertilizerApplicationRate = 0
    },
    submitSeedSeedingRateEdit (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: this.cropSeedEditItem,
        seedingRate: this.formSeedSeedingRate
      }
      this.$store.dispatch('updateCropSeedDetailSeedingRate', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })

      // reset the values
      this.cropSeedEditItem = ''
      this.formSeedSeedingRate = 0
    },
    submitCommodityProductionEdit (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: this.cropCommodityEditItem,
        production: this.formCommodityProduction
      }
      this.$store.dispatch('updateCropCommodityDetailProduction', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })

      // reset the values
      this.cropCommodityEditItem = ''
      this.formCommodityProduction = 0
    },
    submitOtherIncomeQuantityEdit (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: this.cropOtherIncomeEditItem,
        quantity: this.formOtherIncomeQuantity
      }
      this.$store.dispatch('updateCropOtherIncomeDetailQuantity', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })

      // reset the values
      this.cropOtherIncomeEditItem = ''
      this.formOtherIncomeQuantity = 0
    },
    submitIrrigationQuantityEdit (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: this.cropIrrigationEditItem,
        quantity: this.formIrrigationQuantity
      }

      this.$store.dispatch('updateCropIrrigationDetailQuantity', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })

      // reset the values
      this.cropIrrigationEditItem = ''
      this.formIrrigationRate = 0
    },
    deleteCropIncomeCommodityItem (itemId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: itemId,
        cropId: this.cropId
      }
      this.$store.dispatch('deleteCropIncomeCommodityItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    deleteCropIncomeOtherIncomeItem (itemId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: itemId,
        cropId: this.cropId
      }
      this.$store.dispatch('deleteCropIncomeOtherIncomeItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    deleteCropExpenseChemicalItem (itemId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: itemId,
        cropId: this.cropId
      }
      this.$store.dispatch('deleteCropExpenseChemicalItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    deleteCropExpenseFertilizerItem (itemId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: itemId,
        cropId: this.cropId
      }

      this.$store.dispatch('deleteCropExpenseFertilizerItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    deleteCropExpenseSeedItem (itemId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: itemId,
        cropId: this.cropId
      }
      this.$store.dispatch('deleteCropExpenseSeedItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    },
    deleteCropExpenseIrrigationItem (itemId) {
      const jsConn = new JSConn()

      jsConn.formParams = {
        itemId: itemId,
        cropId: this.cropId
      }

      this.$store.dispatch('deleteCropExpenseIrrigationItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
